export const formatToOnlyDigit = (value: unknown) => {
  return String(value).replace(/\D/g, '');
};
